import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';

export default function WaitlistSignup() {
  const [searchParams] = useSearchParams();
  const path = searchParams.get('path') || '2'; // Default to Path 2
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [status, setStatus] = useState(''); // 'success', 'error', or ''

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    // Create the form data for Web3Forms
    const data = {
      access_key: "YOUR_WEB3FORMS_ACCESS_KEY", // You'll need to replace this
      subject: `Waitlist Sign-up for Path ${path}`,
      from_name: formData.name,
      email: formData.email,
      to_email: "yphilipos@gmail.com",
      message: `New waitlist sign-up for Path ${path}\n\nName: ${formData.name}\nEmail: ${formData.email}`
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      
      if (result.success) {
        setStatus('success');
        setFormData({ name: '', email: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <div className="pt-32 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-sage-100 text-sage-700 rounded-full text-sm font-medium mb-6">
              Join the Waitlist
            </div>
            <h1 className="text-4xl md:text-5xl font-serif font-light text-gray-900 mb-6">
              Reserve Your Spot for Path {path}
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Path {path} is coming soon! Enter your information below and we'll notify you when enrollment opens.
            </p>
          </div>

          {/* Form */}
          <div className="bg-gradient-to-br from-sage-50 to-warm-50 rounded-2xl p-8 md:p-12 shadow-lg">
            {status === 'success' ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-sage-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h2 className="text-2xl font-serif font-light text-gray-900 mb-4">
                  You're on the list!
                </h2>
                <p className="text-gray-600 mb-8">
                  We'll send you an email as soon as Path {path} opens for enrollment. Keep an eye on your inbox!
                </p>
                <button
                  onClick={() => setStatus('')}
                  className="text-sage-600 hover:text-sage-700 font-medium transition-colors"
                >
                  Sign up another person
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border-2 border-sage-200 rounded-lg focus:border-sage-500 focus:outline-none transition-colors"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border-2 border-sage-200 rounded-lg focus:border-sage-500 focus:outline-none transition-colors"
                    placeholder="your@email.com"
                  />
                </div>

                {status === 'error' && (
                  <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">
                      Oops! Something went wrong. Please try again or email us directly at yphilipos@gmail.com
                    </p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={status === 'submitting'}
                  className="w-full bg-sage-600 text-white py-4 px-8 rounded-lg font-medium hover:bg-sage-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {status === 'submitting' ? 'Submitting...' : 'Reserve My Spot'}
                </button>

                <p className="text-sm text-gray-500 text-center">
                  By signing up, you'll receive updates about Path {path} enrollment. You can unsubscribe anytime.
                </p>
              </form>
            )}
          </div>

          {/* Additional Info */}
          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-4">
              Questions about the program?
            </p>
            <a
              href="mailto:yphilipos@gmail.com"
              className="inline-flex items-center text-sage-600 hover:text-sage-700 font-medium transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email us at yphilipos@gmail.com
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
